import { TESTIDS } from "@/constants/testIds";
import { ArrowUpRight } from "lucide-react";

const examples = [
  "Empresas de construcción activas en la RM",
  "Contactos de abogados por comuna",
  "Emprendedores con redes sociales activas",
  "Comercios por rubro en regiones específicas",
  "Listados de propiedades con información pública",
  "Restaurantes y cafeterías por zona",
  "Importadoras por código arancelario",
  "Clínicas y centros médicos privados",
  "Inmobiliarias con cartera activa",
  "Empresas exportadoras por país destino",
];

export default function Examples() {
  return (
    <section
      data-testid={TESTIDS.examplesSection}
      className="relative py-24 lg:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 mb-14">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-6">
          <div>
            <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#00f0ff] mb-4">
              / 05 — Casos reales
            </div>
            <h2 className="font-display font-black text-white text-4xl sm:text-5xl leading-[1] tracking-tight max-w-2xl">
              Ejemplos de{" "}
              <span className="italic font-light text-[#00f0ff]">pedidos</span>{" "}
              frecuentes
            </h2>
          </div>
          <p className="text-[#94a3b8] text-base max-w-sm">
            Algunas de las bases que entregamos cada semana a equipos
            comerciales en Chile.
          </p>
        </div>
      </div>

      {/* Marquee */}
      <div className="relative">
        <div
          className="absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-[#040812] to-transparent pointer-events-none"
        />
        <div
          className="absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-[#040812] to-transparent pointer-events-none"
        />

        <div className="flex animate-marquee whitespace-nowrap">
          {[...examples, ...examples].map((e, i) => (
            <div
              key={i}
              className="inline-flex items-center gap-3 mx-3 px-6 py-4 rounded-full border border-[rgba(0,240,255,0.15)] bg-[rgba(10,18,36,0.6)] backdrop-blur-md hover:border-[rgba(0,240,255,0.5)] transition-colors"
            >
              <ArrowUpRight className="text-[#00f0ff]" size={16} />
              <span className="text-white text-[14px] font-medium">{e}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
